if (!window.__cropcratesPackageProtection) {
  window.__cropcratesPackageProtection = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-package-protection-checkout]');
    if (!button) return;

    event.preventDefault();

    const variantId = Number(button.dataset.protectionVariantId);
    const alreadyInCart = button.dataset.protectionInCart === 'true';

    if (!variantId) return;

    const originalHTML = button.innerHTML;

    button.disabled = true;

    try {
      if (!alreadyInCart) {
        const response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                  properties: {
                    '_package_protection': 'true'
                  }
                }
              ]
            })
          }
        );

        if (!response.ok) {
          throw new Error('Could not add package protection.');
        }
      }

      window.location.assign(
        window.Shopify.routes.root + 'checkout'
      );
    } catch (error) {
      console.error('[Cropcrates] Package protection:', error);

      button.innerHTML = 'TRY AGAIN';
      button.disabled = false;

      setTimeout(() => {
        button.innerHTML = originalHTML;
      }, 1600);
    }
  });
}